export default __webpack_public_path__ + "static/media/flag-comoros.237a21cb.svg";